import { cn } from "@/common/utils";
import { ReactNode } from "react";

export default function RoundedButton({
  className,
  icon,
  func,
  disabled,
}: {
  className: string;
  icon: ReactNode;
  func?: () => void;
  disabled?: boolean;
}) {
  const onClick = () => {
    if (typeof func !== "undefined") func();
  };
  return (
    <button
      disabled={typeof disabled === "undefined" ? false : disabled}
      onClick={onClick}
      className={cn(
        "rounded-full w-9 h-9 flex items-center justify-center",
        className
      )}
    >
      {icon}
    </button>
  );
}
